import { formValidationOptions } from 'modules/billing/TemporaryFund/configs/temporaryFundConfigs';
import { showFormErrorMessage } from 'modules/billing/TemporaryFund/helpers/temporaryFundHelpers';
import React, { useContext } from 'react';
import { Controller } from 'react-hook-form';
import TimezoneDatePicker from 'components/common/TimezoneDatePicker/TimezoneDatePicker';
import { UserDetailsContext } from 'context/userDetailsContext';

const TemporaryFundCreateDateV2 = (props) => {
  const { control, errors } = props;
  const userContext = useContext(UserDetailsContext);
  return (
    <div className="d-flex align-items-top py-2 flex-wrap">
      <div className="col-12 col-sm-4 pt-2">
        Date<span className="alert-star">*</span>
      </div>
      <div className="col-12 col-sm-8">
        <Controller
          control={control}
          name={formValidationOptions?.recordCreateDate?.name}
          rules={formValidationOptions?.recordCreateDate?.rules}
          render={({ field }) => (
            <TimezoneDatePicker
              className="w-100 input-shadow field-icon"
              dateFormat="mm/dd/yy"
              showIcon
              monthNavigator
              yearNavigator
              yearRange={`${new Date().getFullYear() - 100}:${new Date().getFullYear() + 50}`}
              id={field.name}
              name={field.name}
              value={field.value}
              onChange={(value) => field.onChange(value)}
              placeholder="Select"
              timezone={userContext?.userDetails?.timezone}
              isEndOfDay={true}
            />
          )}
        />
        {showFormErrorMessage(formValidationOptions?.recordCreateDate?.name, errors)}
      </div>
    </div>
  );
};

export default TemporaryFundCreateDateV2;
